import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["position", "isVisible", "anchorRef"];
import { forwardRef } from 'react';
import ReactDOM from 'react-dom';
import useRect from "../helpers/useRect";
import PopperContent from "./PopperContent";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * TODO:
 * - Add arrow support
 * - Refactor Tooltip helpers ?
 */

/**
 * This component can be used to display some content on top of another
 */
var PopperRef = function PopperRef(_ref, forwardedRef) {
  var position = _ref.position,
    isVisible = _ref.isVisible,
    anchorRef = _ref.anchorRef,
    popperProps = _objectWithoutProperties(_ref, _excluded);
  var triggerRect = useRect(anchorRef, isVisible);
  return isVisible ? /*#__PURE__*/ReactDOM.createPortal(/*#__PURE__*/_jsx(PopperContent, _objectSpread({
    position: position,
    isVisible: isVisible,
    triggerRect: triggerRect,
    anchorRef: anchorRef,
    ref: forwardedRef
  }, popperProps)), document.body) : null;
};
var Popper = /*#__PURE__*/forwardRef(PopperRef);
export default Popper;